import tableHighlightedContentSelectable from './tableHighlightedContentSelectable';

export default {
  title: 'Highlighted content',
  attributeName: 'contents',
  getURL: 'mainHubCanvasContent/configId',
  createURL: 'rooms',
  updateURL: 'rooms',
  removeURL: 'rooms',
  idAttribute: 'id',
  sessionParams: ['configId'],
  tableConfig: tableHighlightedContentSelectable,
  noArea: true,
  noTitle:true,
  autoUpdate: true,
};
